export const DevtoolsKey = 'devtools-flcia' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
